define(['./CtrlGroupDirective'],
    (CtrlGroupDirective)=> {
        return function () {
            const controlGroupDirectiveObj = new CtrlGroupDirective();
            const origLink = controlGroupDirectiveObj.link;
            controlGroupDirectiveObj.link = function (scope) {
                origLink.apply(this, arguments);
                scope.inline = true;
            };

            return controlGroupDirectiveObj;
        };
    }
);


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/basicinputs/InlineCtrlGroupDirective.js